import React, { FC, useMemo, useCallback } from 'react'
import { Dropdown, Button, Icon } from '@wmgtech/legato'

import { useProject } from 'modules/ProjectEdit/serviceHooks'
import { useConfirmation } from 'components/Project/Confirmation'

import { ArchivedDialog } from 'modulesCommon/Projects/containers'
import { showArchivedDialogVar } from 'modulesCommon/store'

import styles from './management-menu.module.scss'
import { ManagementMenuProps, IOption, IOptionType } from './ManagementMenu.props'

export const ManagementMenu: FC<ManagementMenuProps> = ({ id, onComplete, isActive }) => {

  const { deleteProject } = useProject(id)
  const [onDelete, deleteModal] = useConfirmation<string>(deleteProject, {
    header: 'Delete Project?',
    actionText: 'Delete',
    createMessage: () => <>Are you sure you want to delete this project?</>
  })

  const handleMenuSelect = useCallback(
    async (type: IOptionType) => {
      try {
        switch (type) {
          case 'delete':
            await onDelete({ data: id, message: '' })
            onComplete()
            break

          case 'archive':
            showArchivedDialogVar(true)
            break

          default:
            break
        }
      } catch {
        // TODO handle error or remove catch
      }
    },
    [id, onComplete, onDelete]
  )

  const list = useMemo<ReadonlyArray<IOption>>(
    () => [
      { id: 'archive', title: 'Archive Project', icon: <Icon className={styles.icon} name="box-archive" /> },
      { id: 'delete', title: 'Delete Project', icon: <Icon className={styles.icon} name="trash-can" /> }
    ],
    []
  )

  return (
    <>
      <Dropdown
        list={list.filter(({ id }) => (isActive ? id !== 'activate' : id !== 'archive'))}
        getKey={({ id }) => id}
        getElement={({ title, icon }) => (
          <div className={styles.option}>
            {title} {icon}
          </div>
        )}
        onSelect={({ id }) => handleMenuSelect(id)}
      >
        <Button containerStyle="outline" className={styles.btn} colorType="info" icon="ellipsis" />
      </Dropdown>
      <ArchivedDialog />
      {deleteModal}
    </>
  )
}
